var React = require('react');

function ArrowBefore (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"46","height":"46","rx":"23","fill":"#F7F7F7","key":0}),React.createElement("path",{"d":"M25 28L20 23L25 18","stroke":"#262626","strokeWidth":"1.6","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowBefore.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46","fill":"none"};

module.exports = ArrowBefore;

ArrowBefore.default = ArrowBefore;
